import { Home } from '@features/Home'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/')({
  component: Home,
  loader: () => {
    redirect({
      to: '/search',
      throw: true,
    })
  },
})
